var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"expandable-text"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}}),_c('p',[(!_vm.expanded)?_c('a',{on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.expanded = true}}},[_vm._v(" More")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }